import React, { lazy } from 'react'
import { type RetailerRouteComponentProps } from 'legacy/components/RetailerRoute'
import { NotFoundPage } from 'legacy/dash-components/not-found-page/NotFoundPage'
import { DashRoute } from 'legacy/dash-components/dash-route/DashRoute'

const RetailerFundedMarketingCreateCustomCampaignPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerFundedMarketingCreatePage" */
      'domains/retailer-funded-marketing/pages/create/RetailerFundedMarketingCreateCustomCampaignPage'
    )
)
const RetailerFundedMarketingCreateDiscountForNewCustomerPage = lazy(
  () =>
    import(
      /* webpackChunkName: "RetailerFundedMarketingCreatePage" */
      'domains/retailer-funded-marketing/pages/create/RetailerFundedMarketingCreateDiscountForNewCustomerPage'
    )
)

export type campaignType = 'custom-campaign' | 'discount-for-new-customer'

interface RouteParams {
  campaignType: campaignType
}

const RetailerFundedMarketingCreatePage = (props: RetailerRouteComponentProps<RouteParams>) => {
  switch (props.match.params.campaignType) {
    case 'custom-campaign':
      return <RetailerFundedMarketingCreateCustomCampaignPage {...props} />
    case 'discount-for-new-customer':
      return <RetailerFundedMarketingCreateDiscountForNewCustomerPage {...props} />
    default:
      return <DashRoute component={NotFoundPage} />
  }
}

export default RetailerFundedMarketingCreatePage
